export const TriggerCategories = {
  data: {
    icon: 'hubDB',
    theme: 'oz',
    categoryTitleKey: 'automation-ui-enrollment.redesign.events.categories.data.title',
    fallbackTitleKey: 'automation-ui-enrollment.redesign.events.categories.data.fallbackTitle',
    descriptionKey: 'automation-ui-enrollment.redesign.events.categories.data.description',
    sortOrder: 0
  },
  communication: {
    icon: 'campaigns',
    theme: 'thunderdome',
    categoryTitleKey: 'automation-ui-enrollment.redesign.events.categories.communication.title',
    fallbackTitleKey: 'automation-ui-enrollment.redesign.events.categories.communication.fallbackTitle',
    descriptionKey: 'automation-ui-enrollment.redesign.events.categories.communication.description',
    sortOrder: 1
  },
  digitalInteraction: {
    icon: 'ctas',
    theme: 'thunderdome',
    categoryTitleKey: 'automation-ui-enrollment.redesign.events.categories.digitalInteraction.title',
    fallbackTitleKey: 'automation-ui-enrollment.redesign.events.categories.digitalInteraction.fallbackTitle',
    descriptionKey: 'automation-ui-enrollment.redesign.events.categories.digitalInteraction.description',
    sortOrder: 1
  },
  contactInteraction: {
    icon: 'contactDuplicate',
    theme: 'sorbet',
    categoryTitleKey: 'automation-ui-enrollment.redesign.events.categories.contactInteraction.title',
    fallbackTitleKey: 'automation-ui-enrollment.redesign.events.categories.contactInteraction.fallbackTitle',
    descriptionKey: 'automation-ui-enrollment.redesign.events.categories.contactInteraction.description',
    sortOrder: 2
  },
  automation: {
    icon: 'workflows',
    theme: 'default',
    categoryTitleKey: 'automation-ui-enrollment.redesign.events.categories.automation.title',
    fallbackTitleKey: 'automation-ui-enrollment.redesign.events.categories.automation.fallbackTitle',
    descriptionKey: 'automation-ui-enrollment.redesign.events.categories.automation.description',
    sortOrder: 3
  },
  advanced: {
    icon: 'serverlessFunction',
    theme: 'marigold',
    categoryTitleKey: 'automation-ui-enrollment.redesign.events.categories.advanced.title',
    fallbackTitleKey: 'automation-ui-enrollment.redesign.events.categories.advanced.fallbackTitle',
    descriptionKey: 'automation-ui-enrollment.redesign.events.categories.advanced.description',
    sortOrder: 4
  }
};